// BRANDS IMAGE HOVER

//debouncer for resize events
function debounce(func, timeout = 100) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

const initScroller = () => {
    let scrollerBox = document.querySelector(".js-scrollerbox");
    const initBrands = () => {
        //make sure the bar is full
        let brandRows = [
            document.querySelector(".js-brands0"),
            document.querySelector(".js-brands1"),
        ];
        let singleRow = brandRows[0];
        let ogBrands = singleRow.innerHTML;


        if (!singleRow.offsetWidth > 0) return;

        while (singleRow.offsetWidth < window.innerWidth) {
            for (let row of brandRows) {
                row.innerHTML += ogBrands;
            }
        }
        //set speed/duration
        let result;
        result = singleRow.offsetWidth / 35;
        scrollerBox.style.setProperty("--brands-duration", result + "s");
    };

    if (scrollerBox) {
        initBrands();
        window.addEventListener("orientationchange", debounce(initBrands, 200));
        window.addEventListener("resize", debounce(initBrands, 200));
    }
}
export { initScroller }